export default {"src":"/_next/static/media/almonds.5af45531.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};